import styled from 'styled-components';

export const SwitchWrapper = styled.div`
	display: inline-block;
	position: relative;
`;

export const SwitchInput = styled.input`
	opacity: 0;
	position: absolute;
`;

export const SwitchLabel = styled.label`
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
	width: 32px;
	height: 16px;
	background-color: ${(props) =>
		props.disabled
			? '#9e65f9 '
			: props.checked
				? '#FFF'
				: 'linear-gradient(91deg, #4f17aa 1.48%, #ac02f1 99.24%)'};
	border-radius: 30px;
	position: relative;
	display: block;
	transition: background-color 0.3s;
	border: ${(props) =>
		props.disabled ? '1px solid #9e65f9' : '1px solid white'};

	&:before {
		content: '';
		position: absolute;
		top: 2px;
		left: 3px;
		width: 12px;
		height: 12px;
		background-color: ${(props) => (props.checked ? '#49088D' : '#fff')};
		border-radius: 50%;
		transition: transform 0.3s;
		transform: ${(props) =>
			props.checked ? 'translateX(15px)' : 'translateX(0)'};
	}

	&:disabled {
		cursor: not-allowed;
		border: none;
	}
`;
